<p-toast></p-toast>

<div class="container-fluid header-container">
    <div class="header">
        <h1 class="title" style="display: flex; align-items: center;">
            <button type="button" class="back-link" (click)="goBack()">
                <fa-icon class="back-icon" [icon]="faChevronLeft"></fa-icon>
                @if (user) {
                    <span class="avatar" aria-hidden="true">{{ initials }}</span>
                }
                <span class="who">
                    <span class="who-name">{{ user ? user.name : 'Nuevo usuario' }}</span>
                    @if (user) {
                        <small class="who-email">{{ user.email }}</small>
                    }
                </span>
            </button>
            @if (user) {
                <span class="status-chip" [class.inactive]="!user.isActive">
                    <span class="status-dot"></span>{{ user.isActive ? 'Activo' : 'Inactivo' }}
                </span>
            }
        </h1>

        @if (!isNewUser && !isReadOnlyAdmin && (canManageUsers || isOwnProfile)) {
            <div>
                <p-menu #actionsMenu [model]="actionMenuItems" [popup]="true" [appendTo]="'body'">
                    <ng-template pTemplate="item" let-item>
                        <a class="p-menuitem-link" (click)="item.command()">
                            <span class="p-menuitem-icon">
                                <fa-icon [icon]="item.icon"></fa-icon>
                            </span>
                            <span class="p-menuitem-text">{{ item.label }}</span>
                        </a>
                    </ng-template>
                </p-menu>
                <button class="button is-secondary actions-button" (click)="actionsMenu.toggle($event)">
                    <span class="button-content">
                        <fa-icon [icon]="faGear"></fa-icon>
                        <span>Acciones</span>
                        <fa-icon [icon]="faChevronDown" class="chevron-icon"></fa-icon>
                    </span>
                </button>
            </div>
        }
    </div>
</div>

<div class="container-fluid content-page background">
    @if (!isLoading) {
        @if (isReadOnlyAdmin) {
            <div class="notification is-warning is-light">
                Solo un administrador puede modificar a otro administrador. Esta ficha es de solo lectura.
            </div>
        }
        <form class="user-form" [formGroup]="userForm" (ngSubmit)="save()">
            <section class="form-card">
                <h2 class="card-title">Datos personales</h2>
                <div class="columns is-multiline">
                    <div class="column is-6">
                        <div class="field">
                            <label class="label">Nombre *</label>
                            <div class="control">
                                <input
                                    pInputText
                                    type="text"
                                    formControlName="name"
                                    class="input"
                                    [class.is-danger]="userForm.get('name')?.invalid && userForm.get('name')?.touched"
                                />
                            </div>
                            @if (userForm.get('name')?.invalid && userForm.get('name')?.touched) {
                                <p class="help is-danger">El nombre es obligatorio</p>
                            }
                        </div>
                    </div>

                    <div class="column is-6">
                        <div class="field">
                            <label class="label">Email *</label>
                            <div class="control">
                                <input
                                    pInputText
                                    type="email"
                                    formControlName="email"
                                    class="input"
                                    [class.is-danger]="userForm.get('email')?.invalid && userForm.get('email')?.touched"
                                />
                            </div>
                            @if (userForm.get('email')?.invalid && userForm.get('email')?.touched) {
                                <p class="help is-danger">Email inválido</p>
                            }
                        </div>
                    </div>

                    <div class="column is-6">
                        <div class="field">
                            <label class="label">Departamento *</label>
                            <div class="control">
                                <p-dropdown
                                    [options]="departments"
                                    formControlName="department"
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder="Seleccionar departamento"
                                    styleClass="w-full"
                                    [class.is-danger]="userForm.get('department')?.invalid && userForm.get('department')?.touched"
                                ></p-dropdown>
                            </div>
                            @if (userForm.get('department')?.invalid && userForm.get('department')?.touched) {
                                <p class="help is-danger">El departamento es obligatorio</p>
                            }
                        </div>
                    </div>
                </div>
            </section>

            @if (isNewUser) {
                <section class="form-card">
                    <h2 class="card-title">Contraseña</h2>
                    <div class="columns is-multiline">
                        <div class="column is-6">
                            <div class="field">
                                <label class="label">Contraseña *</label>
                                <div class="control">
                                    <input
                                        pInputText
                                        type="password"
                                        formControlName="password"
                                        autocomplete="new-password"
                                        class="input"
                                        [class.is-danger]="userForm.get('password')?.invalid && userForm.get('password')?.touched"
                                    />
                                </div>
                                @if (userForm.get('password')?.invalid && userForm.get('password')?.touched) {
                                    <p class="help is-danger">{{ userForm.get('password')?.hasError('minlength') ? 'La contraseña debe tener al menos 6 caracteres' : 'La contraseña es obligatoria' }}</p>
                                }
                            </div>
                        </div>
                    </div>
                </section>
            }

            <section class="form-card">
                <h2 class="card-title">Acceso</h2>
                <div class="field">
                    <label class="label">Roles *</label>
                    <div class="control role-tags">
                        @for (roleOption of allRoles; track roleOption.value) {
                            <span
                                class="role-tag"
                                [class.selected]="isRoleSelected(roleOption.value)"
                                [class.disabled]="!canManageUsers || isReadOnlyAdmin || (!isAdmin && roleOption.value === 'ADMIN') || isRoleLocked(roleOption.value)"
                                [attr.title]="isRoleLocked(roleOption.value) ? 'No puedes quitarte este rol a ti mismo' : null"
                                (click)="toggleRole(roleOption.value)"
                            >
                                {{ roleOption.label }}
                            </span>
                        }
                    </div>
                    @if (hasLockedRoles) {
                        <p class="field-note">No puedes quitarte a ti mismo los roles de administración.</p>
                    }
                </div>

                <div class="field">
                    <label class="label">Estado</label>
                    <div class="control status-switch-container">
                        <p-inputSwitch
                            formControlName="isActive"
                            (onChange)="onActiveStatusChange($event)"
                        />
                        @if (isOwnProfile && canManageUsers && !isReadOnlyAdmin) {
                            <small class="field-note">No puedes desactivarte a ti mismo.</small>
                        }
                    </div>
                </div>
            </section>

            <div class="action-bar">
                @if (isReadOnlyAdmin) {
                    <span class="action-note">Ficha en solo lectura</span>
                }
                <button
                    type="button"
                    class="button is-outlined cancel-button"
                    (click)="goBack()"
                    [disabled]="isSaving"
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    class="button save-button"
                    [disabled]="isSaving || isReadOnlyAdmin"
                >
                    <fa-icon [icon]="faSave"></fa-icon>
                    {{ isSaving ? (isNewUser ? 'Creando...' : 'Guardando...') : (isNewUser ? 'Crear usuario' : 'Guardar cambios') }}
                </button>
            </div>
        </form>
    } @else {
        <div class="loading-container">
            <p-progressSpinner ariaLabel="loading" styleClass="custom-spinner"/>
        </div>
    }
</div>

@if (isPasswordModalVisible) {
    <div class="modal is-active" role="dialog" aria-modal="true" aria-labelledby="password-modal-title">
        <div class="modal-background" (click)="closePasswordModal()"></div>
        <div class="modal-content">
            <form class="box" (ngSubmit)="savePassword()">
                <h1 id="password-modal-title" class="title">Modificar contraseña</h1>
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <div class="field">
                            <label class="label">Nueva contraseña *</label>
                            <div class="control">
                                <input
                                    type="password"
                                    class="input"
                                    [(ngModel)]="newPassword"
                                    name="newPassword"
                                    autocomplete="new-password"
                                    [class.is-danger]="passwordError"
                                    placeholder="Mínimo 6 caracteres"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="column is-12">
                        <div class="field">
                            <label class="label">Confirmar contraseña *</label>
                            <div class="control">
                                <input
                                    type="password"
                                    class="input"
                                    [(ngModel)]="confirmPassword"
                                    name="confirmPassword"
                                    autocomplete="new-password"
                                    [class.is-danger]="passwordError"
                                    placeholder="Repetir contraseña"
                                />
                            </div>
                            @if (passwordError) {
                                <p class="help is-danger">{{ passwordError }}</p>
                            }
                        </div>
                    </div>
                    <div class="column is-12">
                        <div class="buttons-container">
                            <button type="button" class="button is-outlined cancel-button" (click)="closePasswordModal()" [disabled]="isSavingPassword">Cancelar</button>
                            <button type="submit" class="button save-button" [disabled]="isSavingPassword">
                                {{ isSavingPassword ? 'Guardando...' : 'Guardar' }}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
}

@if (isDeactivationBlockedModalVisible) {
    <app-user-deactivation-blocked-modal
        [clients]="blockedClients"
        (closeEvent)="closeDeactivationBlockedModal()"
    />
}
